import { HTMLMotionProps, motion } from "framer-motion"

interface AnimatedSlidingBlockType extends HTMLMotionProps<"div"> {
  children: any,
  key:string,
  layout?: boolean, 
  slideX?: boolean,
}
const AnimatedSlidingBlock = React.forwardRef<HTMLDivElement, AnimatedSlidingBlockType>(({ children, layout = false, slideX = true, ...props}, ref) => {
  return (
    <motion.div  
      ref={ref}
      layout={layout}
      initial={{ ...(slideX == true ? {x: -5} : {y: -5}), opacity: 0 }}
      animate={{ ...(slideX == true ? {x: 0} : {y: 0}), opacity: 1 }}
      exit={{ ...(slideX == true ? {x: -5} : {y: -5}), opacity: 0 }}
      transition={{ease: "easeOut", duration: 0.2}}
      {...props}
      >
        {children}
    </motion.div>
  )
})

export default AnimatedSlidingBlock
